import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import {auth} from "./Firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import "react-toastify/dist/ReactToastify.css";

const Account = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");

  // firebase auth codes 
  // const [phone, setPhone] = useState("");
  // const [otp1, setOtp2] = useState("");
  // const [showOtp, setShowOtp] = useState(false);


 const [loginData, setLoginData] = useState({
    identifier: "",
    password: "",
  });

  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
    phoneNumber: "",
  });

  // Phone Login UI
  const [showPhoneLogin, setShowPhoneLogin] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);


  const [phoneLogin, setPhoneLogin] = useState({
    phone: "",
    otp: "",
  });

  const [isOtpSent, setIsOtpSent] = useState(false);

  /* ===================== ADDED FORGOT PASSWORD STATES ===================== */
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  /* ======================================================================= */


//   const sendPhoneOtp = async () => {
//   if (!phoneLogin.phone) {
//     toast.error("Please enter a phone number");
//     return;
//   }

//   try {
//     const res = await axios.post(
//       `${process.env.REACT_APP_API_URL}/api/user/send-mobile-otp`,
//       { phoneNumber: phoneLogin.phone }
//     );

//     // Save session id for verification
//     localStorage.setItem("phoneSessionId", res.data.sessionId);

//     toast.success("OTP sent successfully");
//     setIsOtpSent(true);

//   } catch (err) {
//     toast.error(err.response?.data?.message || "Failed to send OTP");
//   }
// };

// const handlePhoneSubmit = async () => {
//   if (!phoneLogin.otp) {
//     toast.error("Enter OTP");
//     return;
//   }
//   const sessionId1 = localStorage.getItem("phoneSessionId");


//   try {
//     const sessionId = localStorage.getItem("phoneSessionId");
    

//     const res = await axios.post(
//       `${process.env.REACT_APP_API_URL}/api/user/verify-mobile-otp`,
//       {
//         sessionId,
//         phoneNumber: phoneLogin.phone,
//         otp: phoneLogin.otp,
//       }
//     );

    
//       localStorage.setItem("token", res.data.token);
//       localStorage.setItem("user", JSON.stringify(res.data.user));
//       toast.success(res.data.message);
//       navigate("/");

//   } catch (err) {
//     toast.error(err.response?.data?.message || "OTP verification failed");
//   }
// };


// fire base auth phone login functions
// const sendPhoneOtp = async () => {
//   try {
//     if (!phoneLogin.phone) return alert("Enter phone number");

//     window.recaptchaVerifier = new RecaptchaVerifier(
//       "recaptcha-container",
//       { size: "invisible" },
//       auth
//     );

//     const confirmation = await signInWithPhoneNumber(
//       auth,
//       "+91" + phoneLogin.phone,
//       window.recaptchaVerifier
//     );

//     window.confirmationResult = confirmation;

//     setIsOtpSent(true);

//     alert("OTP Sent");

//   } catch (err) {
//     console.log(err);
//     alert("Failed to send OTP");
//   }
// };

const sendPhoneOtp = async () => {
  try {
    if (!phoneLogin.phone) return alert("Enter phone number");
    setOtpLoading(true); 

    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,                       // 👈 FIRST
        "recaptcha-container",      // 👈 SECOND
        { size: "invisible" }       // 👈 THIRD
      );
    }

    const appVerifier = window.recaptchaVerifier;

    const confirmation = await signInWithPhoneNumber(
      auth,
      "+91" + phoneLogin.phone,
      appVerifier
    );

    window.confirmationResult = confirmation;

    setIsOtpSent(true);

    toast.success("OTP Sent");

  } catch (err) {
    console.log(err);
    alert("Failed to send OTP");
  }
  finally {
    setOtpLoading(false); 
  }
};






const handlePhoneSubmit = async () => {
  try {
    const result = await window.confirmationResult.confirm(phoneLogin.otp);

    console.log(result.user);
    let phoneNumber = result.user.phoneNumber;

    if(phoneNumber.startsWith("+91")){
      phoneNumber = phoneNumber.slice(3);
    }


    const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/phone-login`, { phoneNumber });

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("user", JSON.stringify(res.data.user));
    toast.success("logged in successfully");

    navigate("/");

    

    // OPTIONAL: send to backend
    // await axios.post("/api/login", {
    //   phone: result.user.phoneNumber
    // });

  } catch (err) {
    console.log(err);
    alert("Invalid OTP");
  }
};




  // OTP Verification (Email)
  const handleOtpVerify = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/user/verify-otp`, {
        email: registerData.email,
        otp,
      });
      toast.success("Registration complete");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "OTP verification failed");
    }
  };

  // Login
   const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/login`,
        loginData
      );
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      toast.success(res.data.message);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    }
  };

  // Register (Email)
  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/register`,
        registerData
      );
      toast.success("OTP sent to your email");
      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.message || "Registration failed");
    }
  };

  /* ===================== FORGOT PASSWORD HANDLER ===================== */
  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!forgotEmail) {
      toast.error("Please enter your email");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/forgot-password`,
        { email: forgotEmail }
      );
      toast.success("Password reset link sent to your email");
      setShowForgotPassword(false);
      setForgotEmail("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send reset link");
    }
  };
  /* =================================================================== */

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row gy-4">

          {/* ============================ LOGIN CARD ============================ */}
          <div className="col-xl-6 pe-xl-5"style={{ marginTop:"-30px",}}>
          <form
  onSubmit={handleLogin}
  className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-70 login-form"
>

              <h6 className="text-xl mb-32">Login</h6>
  <div className="mb-24 mt-24">
                <label className="text-neutral-900 text-lg mb-8 fw-medium">
                  Username <span className="text-danger">*</span>
                </label> <br></br>
                <input
                  type="text"
                  className="common-input"
                  placeholder="Username"
                  value={loginData.identifier}
                  onChange={(e) =>
                    setLoginData({ ...loginData, identifier: e.target.value })
                  }
                  required
                  style={{
    height: "38px",
    minHeight: "38px",
    lineHeight: "38px",
    width: "50%",
    padding: "6px 12px",
    fontSize: "14px",
    boxSizing: "border-box",
    WebkitAppearance: "none",
    appearance: "none",
  }}
                />
              </div>

              <div className="mb-24 mt-24">
                <label className="text-neutral-900 text-lg mb-8 fw-medium">
                  Password <span className="text-danger">*</span>
                </label>
                <br></br>
                <input
  type="password"
  className="common-input"
  placeholder="Enter Password"
  value={loginData.password}
  onChange={(e) =>
    setLoginData({ ...loginData, password: e.target.value })
  }
  required
  style={{
    height: "38px",
    minHeight: "38px",
    lineHeight: "38px",
    width: "50%",
    padding: "6px 12px",
    fontSize: "14px",
    boxSizing: "border-box",
    WebkitAppearance: "none",
    appearance: "none",
  }}
/>




                {/* ================= FORGOT PASSWORD LINK (ADDED) ================= */}
                <div className="d-flex justify-content-start mt-8">
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#ff6a00",
                      fontSize: "14px",
                    }}
                    onClick={() => setShowForgotPassword(true)}
                  >
                    Forgot password?
                  </span>
                </div>
                {/* ================================================================ */}
              </div>

              <button type="submit" className="btn btn-main py-18 px-40"
              style ={{
                width: "50%",
                display: "block",
              }}>
                Log in
              </button>

               <p className=" mt-24" style={{"marginLeft":"120px"}}>OR</p> 

                             {/* <div className="mt-40 border rounded-16 p-24 shadow-sm">
  <button
    type="button"
    onClick={() => setShowPhoneLogin(!showPhoneLogin)}
    className="btn btn-main w-100 py-16 px-20 mb-20"
  >
    Login with Phone Number
  </button>

  {showPhoneLogin && (
    <div className="animate__animated animate__fadeInDown">

     
      <div className="mb-20">
        <label className="text-neutral-900 text-lg mb-8 fw-medium">
          Phone Number <span className="text-danger">*</span>
        </label>
        <input
          type="tel"
          className="common-input"
          placeholder="+91XXXXXXXXX"
          value={phoneLogin.phone}
          onChange={(e) =>
            setPhoneLogin({ ...phoneLogin, phone: e.target.value })
          }
        />
      </div>

      
      {!isOtpSent && (
        <button
          type="button"
          onClick={sendPhoneOtp}
          className="btn btn-main w-100 py-16 px-20 mb-20"
        >
          Send OTP
        </button>
      )}

     
      {isOtpSent && (
        <>
          <div className="mb-24">
            <label className="text-neutral-900 text-lg mb-8 fw-medium">
              OTP <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="common-input"
              placeholder="Enter OTP"
              value={phoneLogin.otp}
              onChange={(e) =>
                setPhoneLogin({ ...phoneLogin, otp: e.target.value })
              }
            />
          </div>

          <button
            type="button"
            onClick={handlePhoneSubmit}
            className="btn btn-main w-100 py-16 px-20"
          >
            Submit & Login
          </button>
        </>
      )}
    </div>
  )}
</div> */}

{/* firebase auth phone login UI */}
                             <div className="mt-40"
                             style={{
                              paddingBottom:"100px",
                              marginBottom:"-80px",
                             }}>
  <button
    type="button"
    onClick={() => setShowPhoneLogin(!showPhoneLogin)}
    className="btn btn-main w-50 py-16 px-20 mb-10"
    style={{marginTop:"-20px"}}
  >
    Login with Phone Number
  </button>

  {showPhoneLogin && (
    <div className="animate__animated animate__fadeInDown">

     
      <div className="mb-20">
        <label className="text-neutral-900 text-lg mb-8 fw-medium">
          Phone Number <span className="text-danger">*</span>
        </label> <br />
        <input
          type="tel"
          className="common-input"
          placeholder="+91XXXXXXXXX"
          value={phoneLogin.phone}
          onChange={(e) =>
            setPhoneLogin({ ...phoneLogin, phone: e.target.value })
          }
           style={{
    height: "38px",
    minHeight: "38px",
    lineHeight: "38px",
    width: "50%",
    padding: "6px 12px",
    fontSize: "14px",
    boxSizing: "border-box",
    WebkitAppearance: "none",
    appearance: "none",
  }}
        />
      </div>

      
      {!isOtpSent && (
  <button
    type="button"
    onClick={sendPhoneOtp}
    disabled={otpLoading}
    className="btn btn-main w-50 py-16 px-20 mb-20"
  >
    {otpLoading ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
        />
        Sending OTP...
      </>
    ) : (
      "Send OTP"
    )}
  </button>
)}


     
      {isOtpSent && (
        <>
          <div className="mb-24">
            <label className="text-neutral-900 text-lg mb-8 fw-medium">
              OTP <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="common-input"
              placeholder="Enter OTP"
              value={phoneLogin.otp}
              onChange={(e) =>
                setPhoneLogin({ ...phoneLogin, otp: e.target.value })
              }
            />
          </div>

          <button
            type="button"
            onClick={handlePhoneSubmit}
            className="btn btn-main w-100 py-16 px-20"
          >
            Submit & Login
          </button>
        </>
      )}
    </div>
  )}
</div>
<div id="recaptcha-container"></div>


            </form>
          </div>

          {/* ============================ REGISTER CARD ============================ */}
          <div className="col-xl-6" style={{marginTop:"-30px",}}>
            {step === 1 ? (
              <form
                onSubmit={handleRegister}
                className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 "
              >
                <h6 className="text-xl mb-32">Register</h6>

                <div className="mb-24">
  <label className="text-neutral-900 text-lg mb-8  fw-medium">
    Username <span className="text-danger">*</span>
  </label>
 <br></br>

  <input
    type="text"
    className="common-input"
    placeholder="Enter username"
    value={registerData.username}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        username: e.target.value,
      })
    }
    required
    style={{
      height: "38px",
      minHeight: "38px",
      lineHeight: "38px",
      width: "50%",
      padding: "6px 15px",
      fontSize: "14px",
    }}
  />
</div>

<div className="mb-24">
  <label className="text-neutral-900 text-lg mb-8 fw-medium">
    First Name <span className="text-danger">*</span>
  </label>
  <br />
  <input
    type="text"
    className="common-input"
    placeholder="Enter first name"
    value={registerData.firstName}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        firstName: e.target.value,
      })
    }
    required
    style={{
      height: "38px",
      width: "50%",
      padding: "6px 15px",
      fontSize: "14px",
    }}
  />
</div>

{/* Last Name */}
<div className="mb-24">
  <label className="text-neutral-900 text-lg mb-8 fw-medium">
    Last Name <span className="text-danger">*</span>
  </label>
  <br />
  <input
    type="text"
    className="common-input"
    placeholder="Enter last name"
    value={registerData.lastName}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        lastName: e.target.value,
      })
    }
    required
    style={{
      height: "38px",
      width: "50%",
      padding: "6px 15px",
      fontSize: "14px",
    }}
  />
</div>


<div className="mb-24">
  <label className="text-neutral-900 text-lg mb-8 fw-medium d-block">
    Email <span className="text-danger">*</span>
  </label>

  <input
    type="email"
    className="common-input"
    placeholder="Enter Email"
    value={registerData.email}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        email: e.target.value,
      })
    }
    required
    style={{
      height: "38px",
      minHeight: "38px",
      lineHeight: "38px",
      width: "50%",
      padding: "6px 15px",
      fontSize: "14px",
    }}
  />
</div>



<div className="mb-24">
  <label className="text-neutral-900 text-lg mb-8 fw-medium d-block">
    Phone Number <span className="text-danger">*</span>
  </label>

  <input
    type="number"
    className="common-input"
    placeholder="+91XXXXXXXXXX"
    value={registerData.phoneNumber}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        phoneNumber: e.target.value,
      })
    }
    required
    style={{
      height: "38px",
      minHeight: "38px",
      lineHeight: "38px",
      width: "50%",
      padding: "6px 15px",
      fontSize: "14px",
    }}
  />
</div>

<div className="mb-24">
  <label className="text-neutral-900 text-lg mb-8 fw-medium d-block">
    Password <span className="text-danger">*</span>
  </label>

  <input
    type="password"
    className="common-input"
    placeholder="Enter Password"
    value={registerData.password}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        password: e.target.value,
      })
    }
    required
    style={{
      height: "38px",
      minHeight: "38px",
      lineHeight: "38px",
      width: "50%",
      padding: "6px 15px",
      fontSize: "14px",
    }}
  />
</div>


                <button type="submit" className="btn btn-main py-18 px-40 w-50">
                  Register
                </button>
              </form>
            ) : (
              <form
                onSubmit={handleOtpVerify}
                className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40"
              >
                <h6 className="text-xl mb-32">Verify OTP</h6>

                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    OTP <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-main py-18 px-40">
                  Verify OTP
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* ===================== FORGOT PASSWORD MODAL ===================== */}
      {showForgotPassword && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
             style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
          <form
            onSubmit={handleForgotPassword}
            className="bg-white rounded-16 p-32"
            style={{ width: "400px" }}
          >
            <h6 className="text-xl mb-24">Forgot Password</h6>

            <input
              type="email"
              className="common-input mb-24"
              placeholder="Enter registered email"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />

            <button type="submit" className="btn btn-main w-100 mb-16">
              Send Reset Link
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary w-100"
              onClick={() => setShowForgotPassword(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}
      {/* ================================================================= */}

      <ToastContainer position="top-right" autoClose={3000} />
    </section>
  );
};

export default Account;
